module.exports = __webpack_public_path__ + "static/media/refund.a6592726.png";